import XQRCode from './x-qrcode';

export default XQRCode;
